import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {

    constructor(
        private modalController: ModalController
    ) { }

    async close() {
        await this.modalController.dismiss();
    }

}
